import packageJson from '../../package.json';

const envs = ['dev', 'prod', 'local', 'qa', 'uat'] as const;

export type TEnv = (typeof envs)[number];

interface IConfig {
  customer: string;
  appType: 'portals' | 'internal_apps' | 'video';
  name: string;
  prodUrl: string;
  version: string;
  env: TEnv;
}

export const appConfig: IConfig = {
  version: packageJson.version,
  name: packageJson.name,
  prodUrl: 'https://eck.spectrumtoolbox.com',
  appType: 'portals',
  customer: 'Charter',
  env: envs.find((env) => process.env.NODE_ENV === env) || 'local',
};
